<template>
  <Html :lang="locale">
    <ClientOnly>
      <Teleport to="body">
        <div class="toast-wrapper">
          <AtomToast
            v-for="(notification, index) in notifications"
            :key="index"
            :notification="notification"
            @close="notifyStore.removeNotification" />
        </div>
      </Teleport>
    </ClientOnly>
    <OrganismCookieBanner />
    <NuxtLayout>
      <NuxtLoadingIndicator :height="2" color="#4aa94a" />
      <NuxtPage />
    </NuxtLayout>
  </Html>
</template>

<script setup lang="ts">
const { t, locale } = useI18n();
const notifyStore = useNotifyStore();
const { notifications } = storeToRefs(notifyStore);
const i18nHead = useLocaleHead();

// Persist locale in cookie when functional consent is granted
const { hasFunctional } = useCookieConsent();
const i18nCookie = useCookie('i18n_redirected', {
  maxAge: 60 * 60 * 24 * 365,
  sameSite: 'strict'
});

watch(
  [hasFunctional, locale],
  ([functional, currentLocale]) => {
    if (functional) {
      i18nCookie.value = currentLocale;
    }
  },
  { immediate: true }
);

// Head configuration
useHead({
  title: 'Home',
  titleTemplate: (title) => `${title} | ${t('App.meta.title') || 'Greenbow'}`,
  meta: [
    {
      name: 'description',
      content:
        t('App.meta.description') ||
        'Få en ladestander installeret derhjemme, grøn strøm til hele husstanden og adgang til et stort roamingnetværk.'
    },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1'
    },
    ...(i18nHead.value.meta || [])
  ],
  link: [
    ...(i18nHead.value.link || []),
    {
      rel: 'icon',
      type: 'image/png',
      href: '/favicon.png'
    }
  ],
  htmlAttrs: { lang: i18nHead.value.htmlAttrs!.lang }
});
</script>
<style scoped lang="scss">
.toast-wrapper {
  position: fixed;
  bottom: 50px;
  right: 20px;
  display: flex;
  flex-direction: column-reverse;
  gap: 10px;
  z-index: 1000; /* Adjust this if other elements are on top */
}

.hidden-content {
  visibility: hidden;
}
</style>
